/* oxlint-disable react/jsx-props-no-spreading -- props are intentionally forwarded by this adapter */
export default function TrackableIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none" {...props}>
      <g clipPath="url(#clip0_11255_27238)">
        <path
          d="M6.00501 0L0.5 5.2764L1.65138 6.37997C1.91501 6.63265 2.27257 6.77461 2.6454 6.77461C3.01823 6.77461 3.37579 6.63266 3.63942 6.37997L5.99502 4.12221L8.35058 6.37996C8.61422 6.63265 8.97178 6.77461 9.34461 6.77461C9.71744 6.77461 10.075 6.63265 10.3386 6.37996L11.5 5.26682L6.00501 0Z"
          fill="currentColor"
        />
        <path
          d="M5.99497 9.49969C7.02126 9.49969 7.85323 8.70227 7.85323 7.71859C7.85323 6.73492 7.02126 5.9375 5.99497 5.9375C4.96869 5.9375 4.13672 6.73492 4.13672 7.71859C4.13672 8.70227 4.96869 9.49969 5.99497 9.49969Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11255_27238">
          <rect width="11" height="9.5" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
